"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultSfilterConfirmGroupState = void 0;
exports.defaultSfilterConfirmGroupState = {
    nameConfirm: 'Confirm',
    nameClear: 'Clear All',
    nameShow: 'Show',
    nameResults: 'Results',
    nameSave: 'Save Search',
    count: -1,
};
